import { useQuery } from "@tanstack/react-query";
import { IStaff } from "../utils/types";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { PaginatedApiResponse } from "../utils/types";

interface PaginationParams {
  page: number;
  perPage: number;
}

const useGetStaff = (params: PaginationParams) => {
  return useQuery({
    queryKey: ["staff", params.page, params.perPage],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get<
        PaginatedApiResponse<IStaff[]>
      >("v1/staff", {
        params: {
          page: params.page,
          perPage: params.perPage,
        },
        headers: {
          pageName: "staff",
        },
      });
      return response.data.result.data;
    },
  });
};

export default useGetStaff;
